export default {
  braceletNo: '标识号',
};
